/** Default when `productType` is missing (existing saree catalog). */
export const DEFAULT_PRODUCT_TYPE = "saree";

/**
 * Stable product family for routing rules, validators, and future verticals.
 * Lowercase slug: letters, digits, dot, underscore, hyphen.
 */
export const normalizeProductType = (value) => {
  const raw = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 48);
  return raw || DEFAULT_PRODUCT_TYPE;
};

/** Type-specific payload (units, cylinder size, license flags, …). Plain object only. */
export const normalizeSpecObject = (v) => {
  if (v && typeof v === "object" && !Array.isArray(v)) return { ...v };
  if (typeof v === "string" && v.trim()) {
    try {
      const p = JSON.parse(v.trim());
      if (p && typeof p === "object" && !Array.isArray(p)) return { ...p };
    } catch {
      /* ignore */
    }
  }
  return {};
};
